/** Fiche société — miroir API. */
import type { Company } from "../../types";

export type CompanyDraft = {
  legal_name: string;
  siret: string;
  siren: string;
  vat_number: string;
  website: string;
  email: string;
  phone: string;
  sector: string;
  address_line: string;
  address_line2: string;
  postal_code: string;
  city: string;
  region: string;
  country_code: string;
  invoice_terms: string;
  invoice_footer: string;
  quote_terms: string;
  quote_footer: string;
  credit_terms: string;
  credit_footer: string;
  iban: string;
  bic: string;
  legal_form: string;
  share_capital: string;
  rcs_city: string;
};

export function companyToDraft(c: Company): CompanyDraft {
  return {
    legal_name: c.legal_name || "",
    siret: c.siret || "",
    siren: c.siren || "",
    vat_number: c.vat_number || "",
    website: c.website || "",
    email: c.email || "",
    phone: c.phone || "",
    sector: c.sector || "",
    address_line: c.address_line || "",
    address_line2: c.address_line2 || "",
    postal_code: c.postal_code || "",
    city: c.city || "",
    region: c.region || "",
    country_code: c.country_code || "FR",
    invoice_terms: c.invoice_terms || "",
    invoice_footer: c.invoice_footer || "",
    quote_terms: c.quote_terms || "",
    quote_footer: c.quote_footer || "",
    credit_terms: c.credit_terms || "",
    credit_footer: c.credit_footer || "",
    iban: c.iban || "",
    bic: c.bic || "",
    legal_form: c.legal_form || "",
    share_capital: c.share_capital || "",
    rcs_city: c.rcs_city || "",
  };
}
